'use strict';

/**
 * Check if the current element is a candidate for collapse behavior - height is set via CSS
 * @param {Object} element - The element to check for collapse height
 */

function collapseNeed (element) {
    return $('#'+element).length && document.getElementById(element).scrollHeight > $('#' + element).innerHeight();
}

const masonryOpt = () => {
    $('.masonry-grid').masonry({
        // options
        itemSelector: '.masonry-grid-item',
        columnWidth: '.masonry-grid-sizer',
        gutter: '.masonry-grid-gutter',
        percentPosition: true
    });
};

class Stories {
    showMoreTextToggle () {
        let element = 'collapseText';
        if(!collapseNeed(element)) {
            $('a[href="#'+element+'"]').hide();
        }
    }

    initMasonryGrid () {
        masonryOpt();
    }

    activeBtn () {
        if (window.sessionStorage.getItem('classificationFolder')) {
            let folderValue = window.sessionStorage.getItem('classificationFolder');
            let btn = $('.container-buttons a').toArray();
            btn.some(fdid => {
                if ($(fdid).data('fdid') == folderValue) {
                    $(fdid).addClass('active');
                    window.sessionStorage.removeItem('classificationFolder');
                    return;
                }
            });

        }
        $('.story-detail-breadcrumbs .classificationFolder').on('click', (e) => {
            window.sessionStorage.setItem('classificationFolder', $(e.currentTarget).data('folderid'));
        });
    }

    updateGrid() {
        $('.container-buttons a').click(function (e) {
            e.preventDefault();
            let storyContainer = $('.masonry-grid')
            let url;
            
            if ($(e.currentTarget).hasClass('active')) {
                url = $('.nav-item-stories').data('updategrid');
                $(e.currentTarget).removeClass('active');
            } else {
                url = $(e.currentTarget).attr('href');
                $('.container-buttons a').removeClass('active');
                $(e.currentTarget).addClass('active');
            }

            $.ajax({
                url: url,
                type: 'get',
                success: function (data) {
                    storyContainer.empty();
                    storyContainer.append(data);
                    $('.masonry-grid').masonry('reloadItems');
                    masonryOpt();
                },
                error: function (err) {
                    console.log(err);
                }
            });
        });
    }


    get init () {
        return {
            showMoreTextToggle: this.showMoreTextToggle(),
            initMasonryGrid: this.initMasonryGrid(),
            updateGrid: this.updateGrid(),
            activeBtn: this.activeBtn()
        };
    }

}

const stories = new Stories;
export default stories;
